//import AppContext from "../AppContext.js";

class Logger
{

    LogClick(message) 
    {
        //AppContext.AppInsights.trackEvent({name: "Click"},{
        //    event:message
        //});
    }

    LogLogin(user) 
    {
       // AppContext.AppInsights.trackEvent({name: "LOGIN"},{
        //    login:user.get('email')
        //});
    }
}
export default new Logger();